import { defineComponent, reactive } from 'vue'
import UEI from '../use/useEditInfo'
import { IContainer } from "../../../json-parse/src/interface";

export default defineComponent({
  name: 'JsonEditRightBar',
  props: {
    scaleOption: {
      type: Function,
      required: true
    },
    submitOption: {
      type: Function,
      // default: () => {}
    }
  },
  setup(props) {
    const state = reactive({
      propsName: '', // 新添加组件的props
      optionScale: false, // option操作栏状态(是否缩放)
    })
    // 给自定义组件添加props
    function addComponentProps(currentLayout:IContainer) {
      if (state.propsName.trim() === '') {
        return alert('props不能为空')
      }
      if (!currentLayout.selfConfig.includes(state.propsName)) {
        currentLayout.selfConfig.push(state.propsName)
        currentLayout[state.propsName] = ''
        state.propsName = ''
      } else {
        alert('props不能重复')
      }
    }
    // 删除自定义props
    function deleteComponentProps(currentLayout:IContainer, keygen:string, index: number) {
      if (currentLayout.selfConfig.includes(keygen)) {
        currentLayout.selfConfig.splice(index, 1)
        delete currentLayout[state.propsName]
      }
    }
    return () => {
      const currentLayout = UEI.state.clickLayout
      if (!currentLayout) UEI.setClickLayout(UEI.state.globalLayout)
      if (!currentLayout) return <div class="comp-option"></div>
      const { styleConfig = {}, attrsConfig = [], eventConfig = [], selfDefineTag, selfConfig } = currentLayout
      let styleConfigKeys = Object.keys(styleConfig)
      return (
        <div class="comp-option">
          <div class="comp-option-section">
            <k-button size="mini" icon="double-arrow-left" 
              onClick={props.scaleOption}
              title="放大或者缩小操作栏"
            >缩放</k-button>
            <k-button
              theme="warning"
              size="mini"
              style="margin-left:10px"
              title="把当前layout布局位置置为原点"
              onClick={() => {
                styleConfig.left = styleConfig.top = 0
              }}
            >
              重置位移
            </k-button>
            <k-button size="mini" style="margin-left:10px" onClick={props.submitOption} 
            title="保存当前修改"
            >保存</k-button>
          </div>
          <div class="comp-option-section">
            <p class="section-item-divid-text">
              布局: {currentLayout.vfor ? '循环:' : '组件:'}
              {currentLayout.tag}
            </p>
            {selfDefineTag ? (
              <div class="section-item">
                <div class="section-item-title">组件tag自定义</div>
                <div class="section-item-con">
                  <input v-model={currentLayout.tag} class="ant-input" placeholder="请输入组件名称(tag)" />
                </div>
              </div>
            ) : null}
            <div class="section-item">
              <div class="section-item-title">container</div>
              <div class="section-item-con">
                <select class="ant-input" placeholder="请选择" style="width: 100%;" v-model={currentLayout['iscontainer']}>
                  <option class="ant-select-dropdown" value={'true'}>
                    是
                  </option>
                  <option class="ant-select-dropdown" value={'false'}>
                    否
                  </option>
                </select>
              </div>
            </div>
            <div class="section-item">
              <div class="section-item-title">isfixed</div>
              <div class="section-item-con">
                <select class="ant-input" placeholder="请选择是否固定" style="width: 100%;" v-model={currentLayout['isfixed']}>
                  <option class="ant-select-dropdown" value={'true'}>
                    是
                  </option>
                  <option class="ant-select-dropdown" value={'false'}>
                    否
                  </option>
                </select>
              </div>
            </div>
          </div>
          {selfDefineTag ? (
            <div class="comp-option-section">
              <p class="section-item-divid-text">自定义组件props</p>
              {selfConfig && selfConfig.length
                ? selfConfig.map((keygen:string, index:number) => {
                    return (
                      <div class="section-item">
                        <div class="section-item-title">{keygen}</div>
                        <div class="section-item-con">
                          <input v-model={currentLayout[keygen]} class="ant-input" placeholder="请输入" />
                        </div>
                        <div class="section-item-operate" style="padding: 0 10px; cursor:pointer;color:red;" onClick={() => deleteComponentProps(currentLayout, keygen, index)}>
                          删除
                        </div>
                      </div>
                    )
                  })
                : null}
              <div class="section-item">
                <div class="section-item-title">添加props</div>
                <div class="section-item-con">
                  <input v-model={state.propsName} class="ant-input" placeholder="请输入props的key" />
                </div>
                <k-button size="small" onClick={() => addComponentProps(currentLayout)}>
                  添加
                </k-button>
              </div>
            </div>
          ) : null}
          {styleConfigKeys && styleConfigKeys.length ? (
            <div class="comp-option-section">
              <p class="section-item-divid-text"> 尺寸定位</p>
              {styleConfigKeys.map(keygen => {
                return (
                  <div class="section-item">
                    <div class="section-item-title">{keygen}</div>
                    <div class="section-item-con">
                      {['width', 'height', 'top', 'left', 'right', 'bottom'].includes(keygen) ? (
                        <input v-model={styleConfig[keygen]} class="ant-input" placeholder="请输入" />
                      ) : keygen === 'position' ? (
                        <select class="ant-input" placeholder="请选择" style="width: 100%;" v-model={styleConfig[keygen]}>
                          <option class="ant-select-dropdown" value={'relative'}>relative</option>
                          <option class="ant-select-dropdown" value={'absolute'}>absolute</option>
                          <option class="ant-select-dropdown" value={'fixed'}>fixed</option>
                        </select>
                      ) : (
                        <input v-model={styleConfig[keygen]} class="ant-input" placeholder="请输入" />
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : null}
          {attrsConfig && attrsConfig.length ? (
            <div class="comp-option-section">
              <p class="section-item-divid-text">
                其他属性:可以插入逻辑
                <p class="section-item-divid-tell">
                  数据说明。"_props:props数据","_ctx:上下文","_con: 用户配置对象","_data===_props.mock", "_refs:dom的引用", "_for:循环数据", "_forIndex:循环数据索引"
                </p>
              </p>
              {attrsConfig.map((keygen:string) => {
                return (
                  <div class="section-item">
                    <div class="section-item-title">{keygen}</div>
                    <div class="section-item-con">
                      {keygen === 'style' ? (
                        <textarea
                          class="ant-input"
                          rows={3}
                          v-model={currentLayout['style']}
                          placeholder='请输入字符串类型:font-size: 12px; 或对象类型:{fontSize: _data.font ? "12px": "14px"}'
                        ></textarea>
                      ) : keygen === 'vfor' ? (
                        <textarea
                          class="ant-input"
                          rows={1}
                          v-model={currentLayout['vfor']}
                          placeholder='请输入循环数据: 引用地址{_data.forList}，固定数据{[{"key":"苹果","val":1},{"key":"香蕉","val":2}]}'
                        ></textarea>
                      ) : keygen === 'vif' ? (
                        <textarea rows={1} v-model={currentLayout['vif']} class="ant-input" placeholder="显示条件如{_data.show}或{true}" />
                      ) : keygen === 'ref' ? (
                        <input
                          value={currentLayout['ref']}
                          onBlur={e => {
                            currentLayout.ref = (e?.target as HTMLInputElement).value
                          }}
                          class="ant-input"
                          placeholder="_refs.xxx获取此dom的引用"
                        />
                      ) : keygen === 'theme' ? (
                        <textarea rows={1}  v-model={currentLayout['theme']} class="ant-input" placeholder="primary|success|warning|danger|info|default" />
                      ) : keygen === 'size' ? (
                        <textarea rows={1}  v-model={currentLayout['size']} class="ant-input" placeholder="large|medium|small|mini" />
                      ) : keygen === 'text' ? (
                        <textarea
                          class="ant-input"
                          rows={1}
                          v-model={currentLayout['text']}
                          placeholder='请输入字符串类型:这个是文本; 或对象类型:{_data.someTitle ? _data.someTitle: "固定标题"}'
                        ></textarea>
                      ) : (
                        <textarea rows={1}  v-model={currentLayout[keygen]} class="ant-input" placeholder="请输入" />
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : null}
          {styleConfigKeys && styleConfigKeys.length ? (
            <div class="comp-option-section">
              <p class="section-item-divid-text">事件绑定</p>
              {eventConfig.map((keygen:string) => {
                return (
                  <div class="section-item">
                    <div class="section-item-title">{keygen}</div>
                    <div class="section-item-con">
                      <textarea class="ant-input" rows={1} v-model={currentLayout[keygen]} placeholder="请输入函数逻辑"></textarea>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : null}
        </div>
      )
    }
  }
})
